import React from 'react';

const PageTitle = ({ additionalClasses, element, updateAnswers, answers, ...props }) => {
  const t = props.t;

  const handleAnchorClick = (e) => {
    e.preventDefault();
    const targetLink = e.target.closest('a');
    if (!targetLink || !element?.answerType) return;
    updateAnswers(element.answerType, targetLink.getAttribute('href').split('#')[1], true);
  };

  return (
    <div className={additionalClasses}>
      <h2 data-cy="page-title" dangerouslySetInnerHTML={{ __html: t(element.text, { answers: answers }) }}></h2>
      <p dangerouslySetInnerHTML={{ __html: t(element.secondary_text, { answers: answers }) }}></p>
      <p onClick={handleAnchorClick} dangerouslySetInnerHTML={{ __html: t(element.tertiary_text, { answers: answers }) }}></p>
    </div>
  );
};

export default PageTitle;
